
gsap.registerPlugin(ScrollTrigger);
gsap.to(".line-progress", {
  height: "100%",
  ease: "none",
  scrollTrigger: {
    trigger: ".pillar-item_main",
    start: "top 60%",
    end: "bottom 60%",
    scrub: 0.5,
  }
});
const items = gsap.utils.toArray(".pillar-item");
items.forEach((item) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 60%",
    end: "bottom 60%",
    onEnter: () => item.classList.add("active"),
    onLeaveBack: () => {
      if (!item.isSameNode(items[0])) {
         item.classList.remove("active");
      }
    },
  });
});